import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
import styles from "./InfoPage.module.scss";
import { Helmet } from "react-helmet-async";

const FeedbackSuccess = () => {
  const { t } = useTranslation("pages");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
        <title>{t("feedbackSuccess.meta.title")}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Nav />

      <div className="container sectionContainer">
        <div className={styles.statusContainer}>
          <div className={styles.iconSuccess}>⭐</div>

          <h1 className={styles.title}>{t("feedbackSuccess.title")}</h1>

          <p className={styles.message}>{t("feedbackSuccess.message")}</p>

          <p className={styles.description}>
            {t("feedbackSuccess.description")}
          </p>

          <div className={styles.buttonGroup}>
            <Link to="/" className={`${styles.button} ${styles.buttonPrimary}`}>
              {t("feedbackSuccess.buttons.backToHome")}
            </Link>

            <Link
              to="/reviews"
              className={`${styles.button} ${styles.buttonOutline}`}
            >
              {t("feedbackSuccess.buttons.viewReviews")}
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FeedbackSuccess;
